import Vue from "vue";
import Vuex from "Vuex";

Vue.use(Vuex);

let store = new Vuex.Store({
  // 用户头像名字openid
  state: {
    nickname: "",
    headimgurl: "",
    userOpenid: "",
    highLightArr:[[],[],[],[]],
    highLightArr2:[[],[],[],[]],
    allTextArr: []
  },
  mutations: {
    delAll(state) {
      state.highLightArr = [[],[],[],[]];
      state.highLightArr2 = [[],[],[],[]];
    },
    updateAllTextArr(state, payload) {
      state.allTextArr = payload;
    },
    addHighLightObj(state,  { obj, index }) {
      //如果有这个对象就不添加,没有就添加
      let flag = state.highLightArr[index].some(item => {
        return item.id === obj.id;
      });
      if (flag) {
        return;
      }
      state.highLightArr[index].push(obj);
      console.log(state.highLightArr, '添加了一个进来');
    },
    addHighLightObj2(state,  { obj, index }) {
      //如果有这个对象就不添加,没有就添加
      let flag = state.highLightArr2[index].some(item => {
        return item.id === obj.id;
      });
      if (flag) {
        return;
      }
      state.highLightArr2[index].push(obj);
      console.log(state.highLightArr2, '添加了一个进来');
    },
    // 删除
    delHighLight(state, {id, index}) {
      let delIndex;
      for(let i in state.highLightArr[index]) {
        if(state.highLightArr[index][i].id === id) {
          delIndex = i
          break;
        }
      }
      state.highLightArr[index].splice(delIndex, 1)
    },
    delHighLight2(state, {id, index}) {
      let delIndex;
      for(let i in state.highLightArr2[index]) {
        if(state.highLightArr2[index][i].id === id) {
          delIndex = i
          break;
        }
      }
      state.highLightArr2[index].splice(delIndex, 1)
    },
    delIndexHighLightArr(state, index) {
      state.highLightArr[index] = [];
    }

  },
  actions: {
    increment(context) {
      context.commit("increment");
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js